import { sessionModeType } from '../../types/Constants';
import { PRIVATE_VIDEO_CHAT_DATA, RECORDING_STATUS, SESSION_DETAILS, SESSION_MODE, SESSION_SETTINGS, SET_ALL_GROUP, SET_GROUP_LEADER, SET_MY_GROUP, SHARE_SCREEN, UPDATE_SETTINGS, WHITEBOARD_DETAILS } from '../../types';

const initialstate = {
    sessionData: {},
    sessionSettingData: {// this defines the session settings as defined by trainer and are applicable to that session.
        showSessionControl: false,
        touchUpAppearance: false,
        showSelfView: false,
        stopCall: false,
        showConnectedTime: false,
        enableGroupIntereaction: true,
        forceMute: false,// default is allowed.
        sessionMode: sessionModeType.NETWORKING_MODE
    },
    recording: false,
    setting: {// this defines the settings selected by trainee as their preference while joining a call.
        audio: true,
        video: true,
        speaker: true
    },
    shareScreen: {
        isShared: false,
        status: 'NA'
    },
    whiteboardDetails: {
        data: {},
        shared: false,
        type: 'self',
        roomId: 0// means not set and pick the user ID as default
    },
    allGroup:[]
};

export default (state: any = initialstate, action: any) => {
    switch (action.type) {
        case SESSION_DETAILS:
            return {
                ...state,
                sessionData: action?.payload
            }
        case SESSION_SETTINGS:
            return {
                ...state,
                sessionSettingData: {
                    ...state.sessionSettingData,
                    ...action?.payload
                }
            }
        case RECORDING_STATUS:
            return {
                ...state,
                recording: action?.payload
            }
        case UPDATE_SETTINGS:
            return {
                ...state,
                setting: action?.payload
            }
        case SET_ALL_GROUP:
            return {
                ...state,
                allGroup: action?.payload
            }
        case SET_MY_GROUP:
            return {
                ...state,
                myGroup: action?.payload
            }
        case SET_GROUP_LEADER:
            return {
                ...state,
                groupLeader: action?.payload
            }
        case SHARE_SCREEN:
            return {
                ...state,
                shareScreen: action?.payload
            }
        case WHITEBOARD_DETAILS:
            return {
                ...state,
                whiteboardDetails: action?.payload
            }

        case PRIVATE_VIDEO_CHAT_DATA:
            return {
                ...state,
                privateVideoChat: action?.payload
            }
        // case SESSION_MODE:
        //     return {
        //         ...state,
        //         sessionMode: action?.payload
        //     }
        default:
            return state;
    }
};